import { Toaster } from 'sonner';

export default function Toast() {
	return <Toaster position="bottom-center" theme="dark" />;
}
